import React from "react";
import { Link } from "react-router-dom";
const Showork = ({ work }) => {
  // const Navigate = useNavigate();
  // const handlework = id => {
  //     Navigate(`/infowork/${id}`);
  // }
  return (
    <>
      {/* <div onClick={() => handlework(work?._id)} className="work-content">
                <div className="work-items">
                    <div className='work-img'>
                        <img className='img-fluid' src={work?.photo1} alt="" />
                        <div className='work-hover'>
                            <h3>{work?.Hover}</h3>
                        </div>
                    </div>
                </div>
            </div> */}
      {/* <div className="figure">
                <img className='img-fluid' src={work.photo1} alt="" />
            </div> */}
      {/* post start 8*/}

      <div className="work-content">
        <Link to="/post8">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://mir-s3-cdn-cf.behance.net/project_modules/fs/74b20b159979225.63aaaa667fc9c.jpg" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Glowy Cosmetics Branding & Packaging</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 8*/}
      {/* post start 12*/}

      <div className="work-content">
        <Link to="/post12">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/5b97ce118185567.61feccbe83d9b.jpg" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Diamonery Brand Identity</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 12*/}
      {/* post start 27*/}

      <div className="work-content">
        <Link to="/post27">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://i.ibb.co/kq8jFj4/1.jpg" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>E Structure Brand Guidelines</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 27*/}
      {/* post start 29*/}

      <div className="work-content">
        <Link to="/post29">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://i.ibb.co/7RV1mSq/1.jpg" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Brand Moodboard</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 29*/}
      {/* post start 1*/}

      <div className="work-content">
        <Link to="/post1">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://i.ibb.co/NpcQG39/1.jpg" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Social Meida Post</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 1*/}
      {/* post start 2*/}

      <div className="work-content">
        <Link to="/post2">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://i.ibb.co/9bL1pZK/1.png" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Nakleika Branding</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 2*/}
      {/* post start 32*/}

      <div className="work-content">
        <Link to="/post32">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://cdn.dribbble.com/userupload/4279054/file/original-6ffb0c338ecd5c789e6ef1fe8c1bb5e0.png?" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Loveletter Logo Design</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 32*/}
      {/* post start 3*/}

      <div className="work-content">
        <Link to="/post3">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://i.ibb.co/KyrDbzJ/10.jpg" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Duck's Store Branding</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 3*/}
      {/* post start 4*/}

      <div className="work-content">
        <Link to="/post4">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://i.ibb.co/kMT94rL/Annie-Ricci-Guidelines-01.jpg" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Annie Ricci Brand Guidelines</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 4*/}
      {/* post start 30*/}

      <div className="work-content">
        <Link to="/post30">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://mir-s3-cdn-cf.behance.net/project_modules/fs/1702de152039529.63171bb57740f.jpg" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Social Media Post Design</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 30*/}
      {/* post start 31*/}

      <div className="work-content">
        <Link to="/post31">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://cdn.dribbble.com/userupload/2502684/file/original-064977a0ba231cd5c086271525aa85d9.png?" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Orbit Logo Design</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 31*/}
      {/* post start 22*/}

      <div className="work-content">
        <Link to="/post22">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://i.ibb.co/6bD6hDS/1-1.png" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Lebskom Website UI</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 22*/}
      {/* post start 5*/}

      <div className="work-content">
        <Link to="/post5">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://i.ibb.co/tbMTk4W/15.jpg" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Oasis Packaging</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 5*/}
      {/* post start 6*/}

      <div className="work-content">
        <Link to="/post6">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://mir-s3-cdn-cf.behance.net/project_modules/fs/305658153700387.63346325b7779.jpg" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Luna Branding & Packaging</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 6*/}

      {/* post start 18*/}

      <div className="work-content">
        <Link to="/post18">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://i.ibb.co/myvk26W/Airtime-Brand-Guideline-01.jpg" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Airtime Brand Guidelines</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 18*/}
      {/* post start 13*/}

      <div className="work-content">
        <Link to="/post13">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://cdn.dribbble.com/users/6827497/screenshots/18010181/media/a7a3c831d035f79db26843f25a966228.jpg" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Cups coffee Logo</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 13*/}
      {/* post start 19*/}

      <div className="work-content">
        <Link to="/post19">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://i.ibb.co/XLTkcyR/1.png" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Ecommerce Website UI</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 19*/}
      {/* post start 23*/}

      <div className="work-content">
        <Link to="/post23">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://i.ibb.co/n3X1kJ1/Brand-Guidelines-01.jpg" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Perspective Brand Guidelines</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 23*/}
      {/* post start 9*/}

      <div className="work-content">
        <Link to="/post9">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://cdn.dribbble.com/users/6827497/screenshots/18334952/media/2a8d49cd3f1579904ed5263124efe074.jpg" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Early Bird</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 9*/}
      {/* post start 7*/}

      <div className="work-content">
        <Link to="/post7">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://mir-s3-cdn-cf.behance.net/project_modules/fs/631218159141967.639a24e223626.jpg" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Apiphen Packaging</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 7*/}
      {/* post start 10*/}

      <div className="work-content">
        <Link to="/post10">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://cdn.dribbble.com/users/6827497/screenshots/18088713/media/40276fc3a850b86db373dcc8819f8f1d.jpg" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Nikon Logo</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 10*/}
      {/* post start 11*/}

      <div className="work-content">
        <Link to="/post11">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://mir-s3-cdn-cf.behance.net/project_modules/1400_opt_1/668035133441343.61bd6bb457740.jpg" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Ikshana Brand Identity</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 11*/}
      {/* post start 33*/}

      <div className="work-content">
        <Link to="/post33">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://cdn.dribbble.com/userupload/3794746/file/original-b5ebf92d65e0d1ff518c609ec773982d.png?" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Sandy Logo Design</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 33*/}
      {/* post start 24*/}

      <div className="work-content">
        <Link to="/post24">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://i.ibb.co/yhy64dc/1-1.png" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Lawyer web & app UI</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 24*/}
      {/* post start 14*/}

      <div className="work-content">
        <Link to="/post14">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://cdn.dribbble.com/users/6827497/screenshots/18189325/media/dbe0d5ca8e74a7228b821e78983f3a78.jpg" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>The Black Stallion Poster</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 14*/}
      {/* post start 20*/}

      <div className="work-content">
        <Link to="/post20">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://i.ibb.co/v18g8gk/1.png" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Formar Cosmetic Brand Website</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 20*/}
      {/* post start 15*/}

      <div className="work-content">
        <Link to="/post15">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://cdn.dribbble.com/users/6827497/screenshots/18389829/media/dbfaaa145fa1a42aea1e20a00e7d7655.jpg" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Turtle Pizza Logo</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 15*/}
      {/* post start 16*/}

      <div className="work-content">
        <Link to="/post16">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://cdn.dribbble.com/users/6827497/screenshots/18109517/media/153efadb8fd14dac841c00855a3302d2.jpg" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Arcad Jinney Logo</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 16*/}
      {/* post start 34*/}

      <div className="work-content">
        <Link to="/post34">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://cdn.dribbble.com/users/4528464/screenshots/18205229/media/9921e67f0d5f4f5a238e127cc3e30042.jpg" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Trinity Brand Logo</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 34*/}
      {/* post start 17*/}

      <div className="work-content">
        <Link to="/post17">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://i.ibb.co/vqjdW6D/1.jpg" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Social Media Post</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 17*/}
      {/* post start 21*/}

      <div className="work-content">
        <Link to="/post21">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://i.ibb.co/cbnLqSP/Another-cos-landing-Copy.jpg" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Mycolenko Website UI</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 21*/}
      {/* post start 26*/}

      <div className="work-content">
        <Link to="/post26">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://mir-s3-cdn-cf.behance.net/project_modules/fs/41e7fb146388751.62aff80e2a3cc.jpg" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Uporova Brand Guideline</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 26*/}
      {/* post start 25*/}

      <div className="work-content">
        <Link to="/post25">
          <div className="work-items">
            <div className="work-img">
              {/* Hover image */}
              <img className="img-fluid" src="https://i.ibb.co/NWcRWZ3/1.png" alt="" />
              <div className="work-hover">
                {/* Hover */}
                <h3>Brand Moodboard</h3>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* post end 25*/}

    </>
  );
};

export default Showork;
